import { TitleSection } from "../title-section";

const channels = [
  {
    title: "Débora Aladim",
    description:
      "O canal Débora Aladim é focado em ensinar História, Sociologia e Filosofia de forma didática e acessível.",
    img: require("../../assets/debora-aladim.png"),
    link: "https://www.youtube.com/@deboraaladim",
  },
  {
    title: "Canal Nostalgia",
    description:
      "O Canal Nostalgia aborda diversos temas relacionados à humanidade, história e muitos outros assuntos, trazendo análises e reflexões sobre a cultura pop e a evolução desses tópicos ao longo do tempo.",
    img: require("../../assets/nostalgia.png"),
    link: "https://www.youtube.com/@nostalgia",
  },
  {
    title: "Se Liga - Enem e Vestibulares",
    description:
      "Conteúdo voltado para estudantes que estão se preparando para o ENEM e vestibulares. Ele disponibiliza resumos, dicas de estudo, explicações de conteúdos importantes.",
    img: require("../../assets/se-liga.png"),
    link: "https://www.youtube.com/@SeLigaEnemeVestibulares",
  },
  {
    title: "Conexão Educação",
    description:
      "Conteúdo voltado para estudantes que estão se preparando para o ENEM e vestibulares. Ele disponibiliza resumos, dicas de estudo, explicações de conteúdos importantes.",
    img: require("../../assets/conexao-educacao.png"),
    link: "https://www.ced.seduc.ce.gov.br/conexao-ensino-medio/disciplinas/",
  },
];

const pod_casts = [
  {
    title: "História em Meia Hora",
    description: "Podcast de História.",
    img: require("../../assets/h30.png"),
    link: "https://open.spotify.com/show/6uscSyqp0q7Cb0uoEujgL8",
  },
  {
    title: "Aprenda Filosofia",
    description: "Podcast de Filosofia.",
    img: require("../../assets/filosofia.png"),
    link: "https://open.spotify.com/show/27zCaxpPbtT1Zr17hkTWDt",
  },
  {
    title: "Geografia em Meia Hora",
    description: "Podcast de Geografia.",
    img: require("../../assets/g30.png"),
    link: "https://open.spotify.com/show/2yHcM4wECyVQEKWIVWTbtt",
  },
];

export const Indication: React.FC = () => {
  return (
    <div id="indications" className="py-10 px-4 lg:px-0 flex justify-center">
      <div className="w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <TitleSection blueToRed={false} first_title="Indicações" />

        <div className="flex flex-col lg:flex-row justify-between gap-8">
          {/* Grid de canais */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 flex-1">
            {channels.map((channel, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="bg-gray-300 h-44 w-full rounded-md mb-4 overflow-hidden">
                  <a href={channel.link}>
                    <img
                      src={channel.img}
                      alt={channel.title}
                      className="object-cover h-full w-full"
                    />
                  </a>
                </div>
                <h3 className="font-bold text-lg text-gray-900 text-center mb-2">
                  <a href={channel.link} className="hover:underline">{channel.title}</a>
                </h3>
                <p className="text-gray-600 text-sm text-center">
                  {channel.description}
                </p>
              </div>
            ))}
          </div>

          {/* Lista lateral de Podcasts */}
          <div className="w-full lg:w-64 flex-shrink-0">
            <div className="grid grid-cols-1 gap-4">
              {pod_casts.map((cast, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 bg-white p-2 rounded-lg shadow-md"
                >
                  <div className="w-16 h-16 bg-gray-300 rounded-md overflow-hidden">
                    <a href={cast.link}>
                      <img
                        src={cast.img}
                        alt={cast.title}
                        className="object-cover h-full w-full"
                      />
                    </a>
                  </div>
                  <div className="flex-1">
                    <a href={cast.link} className="hover:underline">
                      <h4 className="text-gray-900 font-semibold text-sm leading-tight">
                        {cast.title}
                      </h4>
                    </a>
                    <p className="text-gray-500 text-xs leading-tight">
                      {cast.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
